<div class="border-1 bg-white p-4 border-round-lg border-gray-400 flex relative">
  <div class="border-right-1 border-gray-400 mr-2 w-12rem flex">
    <div class="flex flex-column justify-content-between align-items-center">
      <div
        (click)="onShiftPosition.emit(-1)"
        [ngClass]="{
          'text-blue-500 hover:text-blue-300 cursor-pointer': isUpButtonEnabled,
          'text-gray-400': !isUpButtonEnabled
        }"
      >
        <i class="fa fa-angle-up fa-2x"></i>
      </div>
      <!-- Drag Handle -->
      <div class="drag-handle text-gray-400 hover:text-gray-600" cdkDragHandle>
        <i class="la la-grip-vertical la-2x"></i>
      </div>
      <div
        (click)="onShiftPosition.emit(1)"
        [ngClass]="{
          'text-blue-500 hover:text-blue-300 cursor-pointer': isDownButtonEnabled,
          'text-gray-400': !isDownButtonEnabled
        }"
      >
        <i class="fa fa-angle-down fa-2x"></i>
      </div>
    </div>

    <div class="px-2 flex flex-column align-items-center justify-content-center w-full text-center">
      <vehicle-reg>{{ task.vehicleReg }}</vehicle-reg>
      <p class="mb-0 mt-1">{{ task.vehicle }}</p>
    </div>
  </div>

  <div>
    <vertical-dots-container [position]="'start'" [narrowDots]="true" iconSize="small">
    </vertical-dots-container>

    <vertical-dots-container
      [position]="'end'"
      [narrowDots]="true"
      iconSize="small"
      [iconClass]="'fa fa-circle'"
    >
      <div class="-mt-3">
        <h3 class="my-0">{{ task.pickupAddress }}</h3>
        <div class="flex gap-2 align-items-center">
          <i class="fa fa-calendar"></i>
          <p>
            {{ task.customerPickupEarliest | datex : 'ddd, DD MMM, HH:mm' }} -
            {{ task.customerPickupLatest | datex : 'ddd, DD MMM, HH:mm' }}
          </p>
        </div>

        <p class="text-green-500 m-0 py-2 border-top-1 border-bottom-1 border-gray-400">
          {{ task.taskMileage }} mi, {{ task.taskDurationMinutes | minutesToHoursMinutes }}
        </p>
        <h3 class="mb-0">{{ task.dropoffAddress }}</h3>
        <div class="flex gap-2 align-items-center">
          <i class="fa fa-calendar"></i>
          <p>
            {{ task.customerDropoffEarliest | datex : 'ddd, DD MMM, HH:mm' }} -
            {{ task.customerDropoffLatest | datex : 'ddd, DD MMM, HH:mm' }}
          </p>
        </div>
      </div>
    </vertical-dots-container>
  </div>
</div>
